import { render, staticRenderFns } from "./BundleDetails.vue?vue&type=template&id=00753b4a&"
import script from "./BundleDetails.vue?vue&type=script&lang=js&"
export * from "./BundleDetails.vue?vue&type=script&lang=js&"
import style0 from "./BundleDetails.vue?vue&type=style&index=0&id=00753b4a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports